import { InteressedStack } from '../InteressedStack';
import { TechStack } from '../TechStack';
import {SkillsContainer,SkillsContent, SkillsGrid} from './styles';

export function Skills(){
    return(
        <SkillsContent id="skills">
            <SkillsContainer>
                <h2>Skills</h2>
                <p>No front end domino algumas tecnologias</p>
                <SkillsGrid>
                    <TechStack />
                    <InteressedStack />
                </SkillsGrid>
            </SkillsContainer>
        </SkillsContent>
    )
}